<script>
    import { onMount } from "svelte";

    onMount(() => {
        var osInfo = getOS();
        var browserInfo = getBrowser();
        let displayMode = getDisplayMode();
        var popover = null;
        let popoveriPhone = document.getElementById("popoveriPhone");
        let popoveriPad = document.getElementById("popoveriPad");
        let popoverAndroid = document.getElementById("popoverAndroid");
        let popoverCloseIcon = document.getElementById("popover-close-icon");

        checkHomeScreen();

        function runPopover() {
            var showPopover = true;
            var device = getDevice();

            if (osInfo === "iOS" && browserInfo === "Safari") {
                if (device == "iPhone") {
                    popover = popoveriPhone;
                    showPopover = true; // not needed if bottom shoPopover is uncommented
                } else {
                    // popover = popoveriPad;
                    showPopover = false;  // not needed if bottom shoPopover is uncommented
                }
                // showPopover = true;
            } else if (osInfo === "Android" && browserInfo === "Chrome") {
                popover = popoverAndroid;
                // showPopover = true;  commented out until testing can be conducted
                showPopover = false;
            }

            if (
                displayMode === "standalone" ||
                displayMode === "standalone-ios"
            ) {
                showPopover = false;
            }

            if (showPopover) {
                if (popover != null) {
                    popover.classList.remove("popoverInitial");

                    var offset = getOffset(popover);
                    var topPadding = 25;

                    popoverCloseIcon.addEventListener("click", function () {
                        closePopover(100);
                    });

                    //Dismiss
                    setTimeout(function () {
                        closePopover(1);
                    }, 20000);
                }
            } //Show popover
        }

        function closePopover(exp) {
            if (popover !== null) {
                popover.remove();
            }
        }

        function getOS() {
            var userAgent = window.navigator.userAgent;
            var platform = window.navigator.platform;
            var macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"];
            var windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"];
            var iosPlatforms = ["iPhone", "iPad", "iPod"];
            var os = null;

            if (macosPlatforms.indexOf(platform) !== -1) {
                os = "Mac OS";
            } else if (iosPlatforms.indexOf(platform) !== -1) {
                os = "iOS";
            } else if (windowsPlatforms.indexOf(platform) !== -1) {
                os = "Windows";
            } else if (/Android/.test(userAgent)) {
                os = "Android";
            } else if (!os && /Linux/.test(platform)) {
                os = "Linux";
            }

            return os;
        }

        function getBrowser() {
            var userAgent = window.navigator.userAgent;

            var browser = "Other";

            if (/Version/.test(userAgent)) {
                browser = "Safari";
            } else if (/Chrome/.test(userAgent)) {
                browser = "Chrome";
            }

            return browser;
        }

        function getDevice() {
            return window.navigator.platform;
        }

        function checkHomeScreen() {
            var field = "a2hs";
            var url = window.location.href;
            if (url.indexOf("?" + field) !== -1) {
                closeCookie(100);
            }
        }

        function getOffset(element) {
            if (!element.getClientRects().length) {
                return { top: 0, left: 0 };
            }

            let rect = element.getBoundingClientRect();
            let win = element.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset,
            };
        }

        //Track how the PWA was launched
        function getDisplayMode() {
            let displayMode = "browser tab";
            if (navigator.standalone) {
                displayMode = "standalone-ios";
            }
            if (window.matchMedia("(display-mode: standalone)").matches) {
                displayMode = "standalone";
            }
            // Log launch display mode to analytics
            console.log(displayMode);
            return displayMode;
        }

        setTimeout(function () {
            runPopover();
        }, 0);
    });
</script>

<style>
    #containerPop {
        margin: 0 auto;
        width: 100%;
        height: 0;
        background-color: #126697;
        text-align: center;
    }

    .popoverInitial {
        display: none;
    }

    #popoveriPhone {
        position: fixed;
        left: calc((100% - 220px) / 2);
        bottom: 20px;
        width: 208px;
        min-height: 80px;
        padding: 10px;
        background-color: rgb(0, 146, 159);
        border: 4px solid#98c21f;
        border-radius: 5px;
        z-index: 9999 !important;
        text-align: center;
        box-shadow: 10px 10px 60px #555;
    }

    #popoveriPad {
        position: fixed;
        top: 20px;
        left: calc((100% + 340px) / 2);
        width: 208px;
        height: 180px;
        min-height: 80px;
        padding: 10px;
        background-color: rgb(0, 146, 159);
        border: 2px solid#98c21f;
        border-radius: 5px;
        z-index: 9999;
        text-align: center;
        box-shadow: 10px 10px 30px #333, -10px -10px 30px #333,
            -10px 10px 30px #333, 10px -10px 30px #333;
    }

    @media screen and (min-width: 1024px) {
        #popoveriPad {
            left: calc((100% + 508px) / 2);
        }
    }

    @media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: landscape) {
        #popoveriPad {
            left: calc((100% + 610px) / 2);
        }
    }

    @media screen and (min-width: 1366px) {
        #popoveriPad {
            left: calc((100% + 848px) / 2);
        }
    }

    #popoverAndroid {
        position: fixed;
        margin: 0 auto;
        width: 208px;
        left: 20%;
        min-height: 80px;
        padding: 10px;
        background-color: rgb(0, 146, 159);
        border: 2px solid #98c21f;
        -border-radius: 5px;
        z-index: 9999;
        text-align: center;
        box-shadow: 10px 10px 30px #333, -10px -10px 30px #333,
            -10px 10px 30px #333, 10px -10px 30px #333;
    }

    #popoveriPhone::after {
        /* triangle below popup */
        position: absolute;
        content: "";
        height: 0;
        width: 0;
        left: 43%;
        bottom: -20px;
        border-left: 20px solid transparent;
        border-right: 20px solid transparent;
        border-top: 20px solid #98c21f;
        z-index: 9999;
    }

    #popoveriPad::after {
        position: absolute;
        content: "";
        height: 0;
        width: 0;
        left: 43%;
        top: -20px;
        border-left: 20px solid transparent;
        border-right: 20px solid transparent;
        border-bottom: 20px solid #98c21f;
        z-index: 9999;
    }

    #popoveriPhone p,
    #popoverAndroid p,
    #popoveriPad p {
        color: #fff;
        font-size: 16px;
        font-weight: 700;
        font-family: Helvetica, Arial, sans-serif;
    }

    #popover-close-icon {
        position: absolute;
        width: 0;
        right: 20px;
        top: 0;
        font-size: 24px;
        font-weight: bolder;
        color: #fff;
        text-shadow: 0 -1px 1px #00234c;
        cursor: pointer;
    }
</style>

<div id="containerPop">
    <div id="popoveriPhone" class="popoverInitial">
        <div id="popover-close-icon">&times;</div>
        <p>
            <img
                src="../../Uball Dark Gray.png"
                height="72px"
                alt="ulterra logo" />
        </p>

        <p>
            Install this web app to enable offline use: tap
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-share"><path
                    d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
                <polyline points="16 6 12 2 8 6" />
                <line x1="12" y1="2" x2="12" y2="15" /></svg>
            and then Add to Home Screen
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-plus-square"><rect
                    x="3"
                    y="3"
                    width="18"
                    height="18"
                    rx="2"
                    ry="2" />
                <line x1="12" y1="8" x2="12" y2="16" />
                <line x1="8" y1="12" x2="16" y2="12" />
            </svg>
        </p>
    </div>

    <div id="popoveriPad" class="popoverInitial">
        <div id="popover-close-icon">&times;</div>
        <p>
            <img
                src="../../Uball Dark Gray.png"
                height="72px"
                alt="ulterra logo" />
        </p>
        <p>
            Install this web app to enable offline use: tap
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-share"><path
                    d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
                <polyline points="16 6 12 2 8 6" />
                <line x1="12" y1="2" x2="12" y2="15" /></svg>
            and then Add to Home Screen
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-plus-square"><rect
                    x="3"
                    y="3"
                    width="18"
                    height="18"
                    rx="2"
                    ry="2" />
                <line x1="12" y1="8" x2="12" y2="16" />
                <line x1="8" y1="12" x2="16" y2="12" />
            </svg>
        </p>
    </div>

    <div id="popoverAndroid" class="popoverInitial">
        <div id="popover-close-icon">&times;</div>
        <p>
            <img
                src="../../Uball Dark Gray.png"
                height="72px"
                alt="ulterra logo" />
        </p>
        <p>
            To add this web app to the home screen open the browser option menu
            and tap on
            <strong>Add to Home screen</strong>
        </p>
        <p>
            The menu can be accessed by pressing the menu hardware button if
            your device has one, or tapping the top right menu icon.
        </p>
    </div>
</div>
